import { call, put, select } from 'redux-saga/effects'
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* getHistoricalQoeMetricsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const podId = action.payload.podId;
  const deviceMac = action.payload.deviceMac;

  if (sessionToken) {
    let params = { routerMac: rMac }
    let url = 'qoe/podMetrics'
    if (podId) {
      params.podId = podId;
    }
    if (deviceMac) {
      url = 'qoe/deviceMetrics'
      params.deviceMac = deviceMac;
    }
    try {
      const requestConfig = {
        method: 'get',
        url,
        params
      }
      const response = yield axios(requestConfig);
      if (response.status === 200) {
        yield put(actions.getQoeSuccess(response.data));
      } else {
        //console.log('FAILED QOE')
        yield put(actions.getQoeFailed());
      }

    } catch (error) {
      console.error('CHANGE QOE  ERROR', error)
      yield put(actions.getQoeFailed());
    }
  } else {
    //console.log('NO TOKEN')
    yield put(actions.getQoeFailed());

  }
}

const getDevicesStatus = (qoeScoresDevices = [], realDevices = []) => {
  // loop over realDevices
  // ignore ethernet devices
  // check if device[i] has a QoE score available
  // >>> check for "calculating" status
  // >>> check for any FAILING status
  // >>> check for PASSING QoE score
  // add device[i] to "qoeDevices" (IF qoe score fails OR signalStatus is N/A)

  let wifiServiceDevicesFailedCount = 0;
  let wifiServiceDeviceCalStatus = 0;
  let qoeDevices = [];

  realDevices.forEach((device) => {
    if (device.medium === "ethernet") { return; }

    qoeScoresDevices.forEach((d) => {
      if (d.mac === device.mac) {
        if (device.health && (device.health.status === 'calculating' || device.health.status === 'Calculating')) {
          wifiServiceDeviceCalStatus++;
        } else if (device.connectionState !== 'connected') {
          wifiServiceDevicesFailedCount++;
          device.weightedQoeScore = d.weightedQoeScore;
          qoeDevices.push(device);
        } else {
          if (
            d.weightedQoeScore < 3 ||
            d.weightedQoeScore === 'N/A' ||
            !d.weightedQoeScore
          ) {
            wifiServiceDevicesFailedCount++;
            device.weightedQoeScore = d.weightedQoeScore;
            qoeDevices.push(device);
          }
        }

        if (device.deviceSignalStatus === 'N/A') {
          device.weightedQoeScore = d.weightedQoeScore;
          qoeDevices.push(device);
        }
      }
    });
  });

  return {
    wifiServiceDeviceCalStatus,
    wifiServiceDevicesFailedCount,
    qoeDevices,
  }
}

const getPodStatus = (qoeScoresNodes = [], claimedPods = [], minPassingScore = 3) => {
  let wifiServicePodsCalStatus = 0;
  let wifiServicePodsFailedCount = 0;
  let qoePods = [];

  // For each QoE node, find its matching claimed pod (by nodeId === claimedPod.id).
  // Only evaluate pods that are actually claimed, and classify each on its real state:
  //   - calculating: the pod's health status is still calculating
  //   - failing:     the pod is not connected, or its QoE score is N/A / below the passing threshold
  //   - passing:     otherwise (increment nothing)
  // Non-matching claimed pods are NOT counted as failures.
  //
  // The QoE node and the claimed pod carry the same signal (qoe node
  // `weightedQoeScore` ~= claimedPod.health.score, and both expose a `status`),
  // so we take the QoE node's values as primary and fall back to the pod's
  // health.score / health.status when the node omits them.
  qoeScoresNodes.forEach((qoePod) => {
    const claimedPod = claimedPods.find((cPod) => cPod.id === qoePod.nodeId);
    if (!claimedPod) { return; }

    qoePods.push(qoePod.nodeId);

    const health = claimedPod.health || {};

    // Status: prefer the QoE node status, fall back to the pod health status.
    const status = String(qoePod.status || health.status || '').toLowerCase();

    // Score: prefer the QoE node weightedQoeScore, fall back to the pod health score.
    let score = qoePod.weightedQoeScore;
    if (score === 'N/A' || score === undefined || score === null) {
      score = health.score;
    }
    const scoreIsUnavailable = score === 'N/A' || score === undefined || score === null;

    if (status === 'calculating') {
      wifiServicePodsCalStatus++;
    } else if (
      claimedPod.connectionState !== 'connected' ||
      scoreIsUnavailable ||
      Number(score) < minPassingScore
    ) {
      wifiServicePodsFailedCount++;
    }
    // else: pod is connected and meets the passing score -> passing, count nothing
  });

  return {
    wifiServicePodsCalStatus,
    wifiServicePodsFailedCount,
    qoePods,
  }
}

const getOverallStatus = (wifiServiceDevicesFailedCount, wifiServiceDeviceCalStatus, wifiServicePodsFailedCount, wifiServicePodsCalStatus, realWan) => {
  try {
    const routerNotConnected = realWan.connectionState === 'disconnected' || realWan.connectionState === 'unavailable'
    const routerLowHealth = realWan.health.score < 3;
    const failingPodsOrDevices = wifiServiceDevicesFailedCount > 0 || wifiServicePodsFailedCount > 0
    const calculatingPodsOrDevices = wifiServiceDeviceCalStatus > 0 || wifiServicePodsCalStatus > 0

    const overallFailure = failingPodsOrDevices || routerLowHealth || routerNotConnected
    const overallNotAvail = !failingPodsOrDevices && calculatingPodsOrDevices

    return (
      overallFailure === false
        ? overallNotAvail === false
          ? 'Pass'
          : 'N/A'
        : 'Fail'
    )

  } catch (e) {
    throw new Error(e)
  }
}

export function* getQoeScoresSaga(action) {
  const routerMac = yield call([sessionStorage, 'getItem'], 'mac')
  const sessionToken = yield call([sessionStorage, 'getItem'], 'sessionToken')

  if (sessionToken) {
    try {
      const qoeScoresEndpoint = {
        method: 'get',
        url: '/qoe/scores',
        params: { routerMac }
      }
      const { data: qoeData, status } = yield call(axios, qoeScoresEndpoint);

      // parse the data
      const realDevices = yield select(state => state.devices.realDevices)
      const claimedPods = yield select(state => state.equipment.realEquipment.claimedPods)
      const realWan = yield select(state => state.wan.realWan)

      // calculate scores
      const minPassingScore = (qoeData.metadata && qoeData.metadata.minPassingScore) || 3
      const { wifiServiceDeviceCalStatus, wifiServiceDevicesFailedCount } = yield call(getDevicesStatus, qoeData.devices, realDevices)
      const { wifiServicePodsCalStatus, wifiServicePodsFailedCount } = yield call(getPodStatus, qoeData.nodes, claimedPods, minPassingScore)
      const wifiServiceCheckOverallPerf = yield call(getOverallStatus, wifiServiceDevicesFailedCount, wifiServiceDeviceCalStatus, wifiServicePodsFailedCount, wifiServicePodsCalStatus, realWan)


      // send results to the logging service
      const sourceTechMobile = yield call([sessionStorage, 'getItem'], 'techMobile')
      const browser = sourceTechMobile === 'true' ? 'TECH_MOBILE' : 'WEB_CLIENT'
      yield put(actions.logQoeResults(browser, wifiServiceCheckOverallPerf, qoeData, routerMac))

      if (status === 200) {
        yield put(actions.getQoeScoresSuccess(qoeData));
      } else {
        yield console.error('QoE Saga encountered an error.')
        yield put(actions.getQoeScoresFailed(error));
      }

    } catch (error) {
      yield console.error('ERROR CALCULATING QOE SCORES', error)
      yield put(actions.getQoeScoresFailed(error));

    }
  } else {
    yield put(actions.getQoeScoresFailed());

  }

}

export function* logQoeResultsSaga(action) {
  const { browser, overallStatus, qoeData, routerMac } = action

  const qoeLoggingEndpoint = yield {
    method: 'post',
    url: '/qoe/logWscEvent',
    data: {
      routerMac,
      browser,
      overallStatus,
      qoeData,
    }
  }

  try {
    yield call(axios, qoeLoggingEndpoint);
  } catch (e) {
    console.error('Unable to log WSC status', e);
  }
}